// Sistema de cache para URLs de archivos
class FileCache {
  constructor() {
    this.cache = new Map()
    this.maxSize = 100 // Máximo 100 archivos en cache
    this.ttl = 30 * 60 * 1000 // 30 minutos TTL
  }

  // Generar clave única para el archivo
  generateKey(r2Key, userId) {
    return `${userId}_${r2Key}`
  }

  // Obtener del cache
  get(r2Key, userId) {
    const key = this.generateKey(r2Key, userId)
    const cached = this.cache.get(key)

    if (!cached) return null

    // Verificar si expiró
    if (Date.now() > cached.expiry) {
      this.cache.delete(key)
      return null
    }

    // Mover al final (LRU)
    this.cache.delete(key)
    this.cache.set(key, cached)

    console.log(`📦 Cache HIT para ${r2Key}`)
    return cached.data
  }

  // Guardar en cache
  set(r2Key, userId, data) {
    const key = this.generateKey(r2Key, userId)

    // Limpiar cache si está lleno (LRU)
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value
      this.cache.delete(firstKey)
      console.log(`🗑️ Cache limpiado: ${firstKey}`)
    }

    const cacheEntry = {
      data,
      expiry: Date.now() + this.ttl,
      timestamp: Date.now(),
    }

    this.cache.set(key, cacheEntry)
    console.log(`💾 Cache MISS - Guardado ${r2Key}`)
  }

  // Limpiar cache específico
  invalidate(r2Key, userId) {
    const key = this.generateKey(r2Key, userId)
    this.cache.delete(key)
    console.log(`🔄 Cache invalidado para ${r2Key}`)
  }

  // Limpiar todo el cache
  clear() {
    this.cache.clear()
    console.log("🧹 Cache completamente limpiado")
  }

  // Obtener estadísticas
  getStats() {
    return {
      size: this.cache.size,
      maxSize: this.maxSize,
      entries: Array.from(this.cache.entries()).map(([key, value]) => ({
        key,
        age: Date.now() - value.timestamp,
        expiresIn: value.expiry - Date.now(),
      })),
    }
  }
}

// Instancia global del cache
export const fileCache = new FileCache()

// Cache para tokens de autenticación
class TokenCache {
  constructor() {
    this.token = null
    this.expiry = 0
  }

  async getToken(user) {
    // Si el token está válido y no expira en los próximos 5 minutos
    if (this.token && Date.now() < this.expiry - 5 * 60 * 1000) {
      console.log("🔑 Token cache HIT")
      return this.token
    }

    console.log("🔑 Token cache MISS - Renovando...")
    this.token = await user.getIdToken()
    // Los tokens de Firebase duran 1 hora
    this.expiry = Date.now() + 55 * 60 * 1000 // 55 minutos para ser seguros

    return this.token
  }

  invalidate() {
    this.token = null
    this.expiry = 0
    console.log("🔑 Token cache invalidado")
  }
}

export const tokenCache = new TokenCache()
